document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("wimCanalEticoOverlay");
  const closeBtn = overlay?.querySelector(".wim-canal-etico__close");
  const acceptBtn = overlay?.querySelector(".wim-canal-etico__accept");

  if (!overlay) return;

  const closePopup = () => {
    overlay.classList.remove("is-active");
    overlay.addEventListener(
      "transitionend",
      () => {
        if (!overlay.classList.contains("is-active")) {
          overlay.setAttribute("aria-hidden", "true");
        }
      },
      { once: true }
    );
  };

  // aceptar → cerrar popup
  acceptBtn?.addEventListener("click", closePopup);

  // X → redirigir al home
  closeBtn?.addEventListener("click", () => {
    window.location.href = "/";
  });

  // tecla ESC → también redirige a home
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      window.location.href = "/";
    }
  });
});

(function() {
  // Observa el body hasta que el contenedor del formulario exista
  const observer = new MutationObserver(() => {
    const formContainer = document.querySelector('shopify-forms-embed');
    console.log("FormContainer: ");
    console.log(formContainer);
    if (formContainer) {
      console.log("existe elemento, desafcitvamos observer");
      observer.disconnect(); // Dejamos de observar una vez encontrado
      setTimeout(() => {
        initFormLogic(formContainer);
      }, 2000);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function initFormLogic(container) {
    console.log("inicializado, tenemos container: ");
    console.log(container);
    // Busca el checkbox y el enlace dentro del formulario
    const checkbox = container.querySelector('input[type="checkbox"]');
    const link = container.querySelector('a');

    console.log(checkbox);
    console.log(link);
    if (!checkbox || !link) return;

    // Deshabilita el checkbox hasta que se abra el enlace
    checkbox.disabled = true;

    link.addEventListener('click', () => {
      checkbox.disabled = false;
      checkbox.classList.add('active'); // opcional, por estilo
    });
  }
})();